import React from 'react';

const CloudArrowUp = (props: object) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.75 16.25H5.625C5.00466 16.2492 4.39157 16.1166 3.82642 15.8608C3.26127 15.605 2.75697 15.2319 2.347 14.7663C1.93703 14.3008 1.63075 13.7534 1.44849 13.1604C1.26623 12.5674 1.21216 11.9425 1.28986 11.327C1.36756 10.7116 1.57525 10.1197 1.89917 9.5906C2.22308 9.06153 2.6558 8.6074 3.16862 8.25834C3.68143 7.90928 4.26262 7.67326 4.87361 7.56595C5.48461 7.45864 6.11143 7.4825 6.7125 7.63593"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.375 12.5L11.875 10L14.375 12.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.875 16.25V10"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.25 9.99853C6.25026 8.87178 6.55512 7.76606 7.13231 6.79837C7.7095 5.83069 8.53755 5.03703 9.52884 4.50139C10.5201 3.96575 11.6378 3.70805 12.7635 3.75556C13.8893 3.80307 14.9812 4.15402 15.9239 4.77128C16.8665 5.38853 17.6248 6.24914 18.1184 7.26201C18.612 8.27489 18.8226 9.40237 18.7279 10.5251C18.6332 11.6479 18.2368 12.7242 17.5806 13.6401C16.9243 14.556 16.0327 15.2775 15 15.7282"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CloudArrowUp;
